module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"loading-text":"Загрузка"},"kg":{"loading-text":"Жүктөө"}}')
  delete Component.options._Ctor
}
